import { axiosInstance } from "@/utils/axios/axiosConfig";
import { Program } from "@/pages/LedReminder/types.ts";

const BASE_URL = "/scheduler/led"; // Assurez-vous que cette URL correspond à votre backend

export const programsApi = {
  // Liste tous les programmes
  listPrograms: async (): Promise<Program[]> => {
    try {
      const response = await axiosInstance.get(BASE_URL);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des programmes:", error);
      throw error;
    }
  },

  // Ajoute un nouveau programme
  addNewProgram: async (program: Program): Promise<Program> => {
    try {
      const response = await axiosInstance.post(BASE_URL, program);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de l'ajout d'un programme:", error);
      throw error;
    }
  },

  // Met à jour un programme existant
  updateProgram: async (program: Program): Promise<Program> => {
    if (!program._id) {
      throw new Error("ID du programme manquant pour la mise à jour");
    }

    try {
      const response = await axiosInstance.patch(
        `${BASE_URL}/${program._id}`,
        program
      );
      return response.data;
    } catch (error) {
      console.error(
        `Erreur lors de la mise à jour du programme ${program._id}:`,
        error
      );
      throw error;
    }
  },

  // Supprime un programme
  deleteProgram: async (programId: string): Promise<void> => {
    try {
      await axiosInstance.delete(`${BASE_URL}/${programId}`);
    } catch (error) {
      console.error(
        `Erreur lors de la suppression du programme ${programId}:`,
        error
      );
      throw error;
    }
  },

  // Récupère un programme spécifique par ID
  getProgramById: async (programId: string): Promise<Program> => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}/${programId}`);
      return response.data;
    } catch (error) {
      console.error(
        `Erreur lors de la récupération du programme ${programId}:`,
        error
      );
      throw error;
    }
  },
};
